import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './loginPage.module.css';
import globalConfig from '../../rest/config';
import { useQuery } from '../../hooks/router.hook';
import { useAuthContext } from '../../store/auth.store';
import routes from '../../utils/routes';
import { useGetUserApi } from '../../hooks/api/auth.hook';
import UrlUtils from '../../utils/url';

/**
 * ログインページ
 */
function LoginSsoCallbackPage() {
  const navigator = useNavigate();

  const query = useQuery();
  const authContext = useAuthContext();
  const getUser = useGetUserApi();

  async function redirect() {
    if (!query.token) return;
    authContext.setToken(query.token);
    const user = await getUser.request();
    const redirectTo = UrlUtils.isValidInternalPath(query.redirect) ? query.redirect : routes.main;
    navigator(redirectTo);
  }

  useEffect(() => {
    redirect();
  }, []);

  // Handler
  return (
    <div />
  );
}

export default LoginSsoCallbackPage;
